/**
 * Create Savings Page
 */
import React from 'react';

const CreateSavings = () => {
  return (
    <div>
      <h1 className="text-2xl font-bold text-gray-900 dark:text-white">Create Savings Account</h1>
      <p className="text-gray-600 dark:text-gray-400 mt-2">Create a new savings account for a member</p>
    </div>
  );
};

export default CreateSavings;
